import { lazy } from 'react';

// The administration's pages, each loaded when its route is first visited — see cabinetPages.ts.
export const InstitutionsAdminPage = lazy(() =>
  import('@/features/admin/institutions/InstitutionsAdminPage').then((m) => ({
    default: m.InstitutionsAdminPage,
  })),
);
export const UsersAdminPage = lazy(() =>
  import('@/features/admin/UsersAdminPage').then((m) => ({ default: m.UsersAdminPage })),
);
export const RolesAdminPage = lazy(() =>
  import('@/features/admin/rbac/RolesAdminPage').then((m) => ({ default: m.RolesAdminPage })),
);
export const AuditPage = lazy(() =>
  import('@/features/admin/AuditPage').then((m) => ({ default: m.AuditPage })),
);
export const ConfigPage = lazy(() =>
  import('@/features/admin/ConfigPage').then((m) => ({ default: m.ConfigPage })),
);
export const NewsAdminPage = lazy(() =>
  import('@/features/news/NewsAdminPage').then((m) => ({ default: m.NewsAdminPage })),
);
export const PagesAdminPage = lazy(() =>
  import('@/features/pages/PagesAdminPage').then((m) => ({ default: m.PagesAdminPage })),
);
export const AdvisoryServicesReportPage = lazy(() =>
  import('@/features/admin/AdvisoryServicesReportPage').then((m) => ({
    default: m.AdvisoryServicesReportPage,
  })),
);
export const SiteHomeAdminPage = lazy(() =>
  import('@/features/siteHome/SiteHomeAdminPage').then((m) => ({ default: m.SiteHomeAdminPage })),
);
export const LibraryAdminPage = lazy(() =>
  import('@/features/library/LibraryAdminPage').then((m) => ({ default: m.LibraryAdminPage })),
);
export const GeoPointAdminPage = lazy(() =>
  import('@/features/geo/GeoPointAdminPage').then((m) => ({ default: m.GeoPointAdminPage })),
);
export const ContactAdminPage = lazy(() =>
  import('@/features/contact/ContactAdminPage').then((m) => ({ default: m.ContactAdminPage })),
);
export const BackupAdminPage = lazy(() =>
  import('@/features/backup/BackupAdminPage').then((m) => ({ default: m.BackupAdminPage })),
);
export const WorkflowDesignerPage = lazy(() =>
  import('@/features/workflow-designer/WorkflowDesignerPage').then((m) => ({
    default: m.WorkflowDesignerPage,
  })),
);
export const WorkQueuePage = lazy(() =>
  import('@/features/workqueue/WorkQueuePage').then((m) => ({ default: m.WorkQueuePage })),
);
export const AdvisorValidationPage = lazy(() =>
  import('@/features/advisors/AdvisorValidationPage').then((m) => ({
    default: m.AdvisorValidationPage,
  })),
);
export const FundingAdminPage = lazy(() =>
  import('@/features/funding/FundingAdminPage').then((m) => ({ default: m.FundingAdminPage })),
);
export const SupportAgencyAdminPage = lazy(() =>
  import('@/features/funding/SupportAgencyAdminPage').then((m) => ({
    default: m.SupportAgencyAdminPage,
  })),
);
export const AdminPage = lazy(() =>
  import('@/features/admin/AdminPage').then((m) => ({ default: m.AdminPage })),
);
export const ForumAdminPage = lazy(() =>
  import('@/features/community/ForumAdminPage').then((m) => ({ default: m.ForumAdminPage })),
);
